import { render, staticRenderFns } from "./GroupThreadSummaryChat.vue?vue&type=template&id=46ba2714&scoped=true"
import script from "./GroupThreadSummaryChat.vue?vue&type=script&lang=js"
export * from "./GroupThreadSummaryChat.vue?vue&type=script&lang=js"
import style0 from "./GroupThreadSummaryChat.vue?vue&type=style&index=0&id=46ba2714&prod&lang=scss"
import style1 from "./GroupThreadSummaryChat.vue?vue&type=style&index=1&id=46ba2714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba2714",
  null
  
)

export default component.exports